import axios from 'axios'
import weui from 'weui.js'
import emktConstant from '../constant.js'
// const UNAUTHORIZED = 401
// const FORBIDDEN = 403
// const ACTION_FAILED = 1
const SUCCESS_CODE = 0

const FormUrlencodedContentType = {
  'Content-Type': 'application/x-www-form-urlencoded'
}
axios.interceptors.request.use(config => {
  return config
}, err => {
  return Promise.resolve(err)
})
axios.interceptors.response.use(response => {
  return response
})
const encodeRequestParams = function (data) {
  let ret = ''
  for (let it in data) {
    const processedData = it === 'SessionId' ? data[it] : JSON.stringify(data[it])
    ret += encodeURIComponent(it) + '=' + processedData + '&'
  }
  return ret
}
export const postRequest = (url, body, showLoading = true) => {
  // 拼装业务员session
  const employeeSession = emktConstant.getUrlParam('EmployeeSession') || ''
  body = {...body, SessionId: employeeSession}
  if (showLoading) weui.loading('加载中')
  return httpRequest({
    method: 'post',
    url: url,
    data: body,
    // data: qs.stringify(body),
    transformRequest: [encodeRequestParams],
    headers: FormUrlencodedContentType
  })
}

export const deleteRequest = (url) => {
  return httpRequest({
    method: 'delete',
    url: `${url}`
  })
}
export const getRequest = (url, param) => {
  return httpRequest({
    method: 'get',
    url: `${url}`,
    params: param,
    transformRequest: [encodeRequestParams]
  })
}

const httpRequest = (requestConfig) => {
  return new Promise(resolve => {
    axios(requestConfig).then(response => {
      if (weui.loading()) weui.loading().hide()
      if (response && response.data && response.data.code === SUCCESS_CODE) {
        resolve(response.data.result)
      } else {
        // 调用emkt getMerchandiseMeta直接返回
        if (requestConfig.url.indexOf('getMerchandiseMeta') > -1) {
          resolve(response.data.result)
        } else {
          alert(response.data.message)
        }
      }
    })
      .catch(e => {
        // (e: { response: { data: any; statusText: string }; message: any })
        console.log('api error: ', e)
        let m = ''
        // 下面是axios的出错处理机制
        if (e.response) {
          // 后台正常报错，如404错误
          const d = e.response.data
          if (d) {
            m = d.status + ', ' + d.error + ', ' + d.message + ', ' + d.timestamp
          } else {
            m = e.response.statusText
          }
        } else {
          // 网络错误
          m = e.message
        }

        alert(m)
      })
  })
}



// WEBPACK FOOTER //
// ./src/emktcommon/api/index.js